import { Button } from '@timelyapp/react';
import classNames from 'classnames';
import type { TrProps } from 'components/ui-blocks/table';
import { Td, Tr } from 'components/ui-blocks/table';
import React from 'react';
import { getDepthStyle } from '../helpers';
import styles from '../TableWidget.module.scss';

interface Props extends TrProps {
  /**
   * The number of visible columns in the table.
   */
  columnCount: number;

  onLoadMore: () => void;
}

const TableWidgetLoadMoreRow: React.FC<Props> = ({
  className,
  columnCount,
  depth,
  onLoadMore,
  ...props
}) => {
  const handleLoadMore = (e: React.MouseEvent) => {
    e.stopPropagation();
    onLoadMore();
  };

  return (
    <Tr className={classNames(styles.loadMore, className)} {...props}>
      <Td colSpan={columnCount + 1} style={getDepthStyle(depth)}>
        <Button size="small" onClick={handleLoadMore}>
          Load more hours
        </Button>
      </Td>
    </Tr>
  );
};

export default TableWidgetLoadMoreRow;
